import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CoreConfigService } from '@core/services/config.service';
import { AuthenticationService } from "../../../auth/service";
import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { coreConfig } from "../../../app-config";
import { Theme } from "../../../../@core/types/app/theme";
import { ApplicationService } from "../../../../@core/services/application.service";
import { AnalyticsService } from "../../../services/analytics.service";

@Component({
  selector: 'app-auth-login-v1',
  templateUrl: './auth-login-v1.component.html',
  styleUrls: ['./auth-login-v1.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthLoginV1Component implements OnInit {
  @ViewChild('wrongPasswordModal') wrongPasswordModal!: TemplateRef<any>;

  public coreConfig: any = coreConfig
  public loginForm: FormGroup;
  public submitted = false;
  public passwordTextType: boolean;
  showLogin = true;
  email: string = '';
  password: string = '';
  username: string = '';
  showPassword = false;
  name: string = '';
  phone: string = '';
  showValidationErrorModal = false;
  validationErrorMessage = 'Per favore, completa tutti i campi obbligatori.';
  showLoginFailureModal = false;
  public sectionAccessName = '';

  private _unsubscribeAll: Subject<any>;

  constructor(
    private modalService: NgbModal,
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private _authenticationService: AuthenticationService,
    private _applicationService: ApplicationService,
    private router: Router,
    private analyticsService: AnalyticsService // Inject AnalyticsService
  ) {
    this._unsubscribeAll = new Subject();

    this._coreConfigService.config = {
      layout: {
        navbar: { hidden: true },
        menu: { hidden: true },
        footer: { hidden: true },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  onSubmit() {
    if (this.loginForm.valid) {
      const { username, password } = this.loginForm.value;
      const eventDetails = `Login attempt - Username: ${username}`;
      this.analyticsService.trackEvent('login_attempt', eventDetails, 'authentication');
      this.login(username, password);
    } else {
      this.wrongCredentials(this.wrongPasswordModal);
    }
  }

  login(username: string, password: string) {
    if (username && password) {
      this._authenticationService.signin(username, password)
        .then(() => {
          const eventDetails = `Login success - Username: ${username}`;
          this.analyticsService.trackEvent('login_success', eventDetails, 'authentication');
        })
        .catch((error) => {
          console.error(error);
          this.validationErrorMessage = 'Errore durante l\'autenticazione.';
          this.wrongCredentials(this.wrongPasswordModal);
        });
    } else {
      this.validationErrorMessage = 'Per favore, completa tutti i campi obbligatori.';
      this.wrongCredentials(this.wrongPasswordModal);
    }
    return new Promise<boolean>((resolve, reject) => {
      this._authenticationService.isAuthenticated()
        .then((response: any) => {
          if (response.status === 404) {
            console.log('User not authenticated');
            this.router.navigate(['/authentication/login']);
            resolve(false);
          } else if (response.status === 401) {
            console.log('Business not authenticated');
            this.router.navigate(['/authentication/business-selection']);
            resolve(false);
          } else {
            console.log('User authenticated');
            resolve(true);
          }
        })
        .catch((error: any) => {
          resolve(false);
        });
    });
  }

  wrongCredentials(modalWrong: TemplateRef<any>): NgbModalRef {
    const eventDetails = 'Login failure - Wrong credentials';
    this.analyticsService.trackEvent('login_failure', eventDetails, 'authentication');
    return this.modalService.open(modalWrong, {
      centered: true,
      size: 'sm',
      windowClass: 'modal modal-primary'
    });
  }

  forgotPassword() {
    this.router.navigate(['/forgot']);
  }

  openLoginFailureModal() {
    this.showLoginFailureModal = true;
  }

  closeLoginFailureModal() {
    this.showLoginFailureModal = false;
  }

  ngOnInit(): void {
    this._applicationService.getTheme().then((themeObservable) => {
      themeObservable.subscribe((theme: Theme) => {
        this.coreConfig = theme;

        if (theme.sections) {
          const customNameSection = theme.sections.find((section) => section.startsWith('access:'));
          if (customNameSection) {
            this.sectionAccessName = customNameSection.split(':')[1];
          }
        }
        if (!this.sectionAccessName) {
          this.sectionAccessName = 'Tulero';
        }
      });
    });

    this._authenticationService.user.subscribe(
      (user) => {
        if (!user) {
          this.validationErrorMessage = 'Credenziali non valide. Riprova.';
          this.openLoginFailureModal();
        }
      },
      (error) => {
        console.error(error);
      }
    );

    this.loginForm = this._formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
